import React, { forwardRef } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Box } from '@mui/material';
import EmptyChart from './EmptyChart';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

const WaterLossBarChart = ({ monthly = [] }, ref) => {
  const months = monthly.map((m) => m.month);
  const nrwData = monthly.map((m) => m.nrwPercent);
  const iliData = monthly.map((m) => m.ili);

  const data = {
    labels: months,
    datasets: [
      {
        label: 'NRW (%)',
        data: nrwData,
        backgroundColor: '#ef4444',
        borderRadius: 6,
        barThickness: 14,
      },
      {
        label: 'ILI',
        data: iliData,
        backgroundColor: '#f59e0b',
        borderRadius: 6,
        barThickness: 14,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 12,
          boxHeight: 12,
          font: {
            size: 12,
            weight: '500',
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const value = ctx.raw?.toLocaleString();
            return `${ctx.dataset.label}: ${value}`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 11,
          },
        },
      },
      y: {
        grid: {
          color: '#e5e7eb',
          drawBorder: false,
        },
        ticks: {
          font: {
            size: 11,
          },
          callback: (value) => `${value}`,
        },
      },
    },
  };

  if (!monthly.length) return <EmptyChart />;

  return (
      <>


      <Box sx={{ flex: 1, minHeight: { xs: 200, md: '165.5px' } }}>
        <Bar ref={ref} data={data} options={options} />
      </Box>
      </>
  );
};

export default forwardRef(WaterLossBarChart);
